// Picking the app's look: a compact switch in the menu and preview cards in Settings
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { api } from './api';
import { applyTheme, currentTheme, THEMES, type Theme } from './theme';
import { Icon } from './icons';
import { toastError } from './ui';

const ICON: Record<Theme, string> = { garage: 'sun', night: 'moon', office: 'layout' };

function useThemeChoice() {
  const qc = useQueryClient();
  const [cur, setCur] = useState<Theme>(currentTheme());
  const pick = async (t: Theme) => {
    applyTheme(t);
    setCur(t);
    try { await api.put('/auth/me', { ui_theme: t }); await qc.invalidateQueries({ queryKey: ['me'] }); } catch (e) { toastError(e); }
  };
  return { cur, pick };
}

export function ThemeSwitch() {
  const { t } = useTranslation();
  const { cur, pick } = useThemeChoice();
  return (
    <div className="theme-switch" role="group" aria-label={t('theme.title')}>
      {THEMES.map(k => (
        <button key={k} type="button" className={cur === k ? 'on' : ''} aria-pressed={cur === k} title={t('theme.' + k)} aria-label={t('theme.' + k)}
          onClick={() => void pick(k)}><Icon name={ICON[k]} size={18} /></button>
      ))}
    </div>
  );
}

export function ThemeCards() {
  const { t } = useTranslation();
  const { cur, pick } = useThemeChoice();
  return (
    <div className="theme-pick" role="radiogroup" aria-label={t('theme.title')}>
      {THEMES.map(k => (
        <button key={k} type="button" role="radio" aria-checked={cur === k} className={'theme-card' + (cur === k ? ' on' : '')} onClick={() => void pick(k)}>
          <div className={'tp tp-' + k} aria-hidden="true"><i className="s" /><div className="c"><i /><i /><i /><i /><i /><i /></div></div>
          <b>{t('theme.' + k)}</b>
          <span>{t('theme.' + k + '_desc')}</span>
        </button>
      ))}
    </div>
  );
}
